import type { LatLngBounds } from 'leaflet';
import { clamp } from 'lodash';

export type LatLngTuple = [number, number];
export type Boundary = LatLngTuple[];

export const isValidCoordinate = (value?: number) =>
  typeof value === 'number' && Number.isFinite(value);

export const isValidCorners = (corners: LatLngTuple[]) =>
  corners.length === 4 &&
  corners.every(([lat, lng]) => isValidCoordinate(lat) && isValidCoordinate(lng));

export const getBoundaryFromBounds = (bounds: LatLngBounds): Boundary => {
  const northWest = bounds.getNorthWest();
  const northEast = bounds.getNorthEast();
  const southEast = bounds.getSouthEast();
  const southWest = bounds.getSouthWest();

  return [
    [clamp(northWest.lat, -90, 90), clamp(northWest.lng, -179.9, 179.9)],
    [clamp(northEast.lat, -90, 90), clamp(northEast.lng, -179.9, 179.9)],
    [clamp(southEast.lat, -90, 90), clamp(southEast.lng, -179.9, 179.9)],
    [clamp(southWest.lat, -90, 90), clamp(southWest.lng, -179.9, 179.9)],
  ];
};

export const getBoundsFromBoundary = (boundary: Boundary) => {
  const lats = boundary.map(([lat]) => lat);
  const lngs = boundary.map(([, lng]) => lng);

  return [
    [Math.max(...lats), Math.min(...lngs)],
    [Math.min(...lats), Math.max(...lngs)],
  ];
};
